(() => {
  const SCROLL_THRESHOLD = 90;

  const updateHeaderState = () => {
    document.body.classList.toggle(
      "ora-header-scrolled",
      window.scrollY > SCROLL_THRESHOLD
    );
  };

  document.addEventListener("DOMContentLoaded", updateHeaderState);

  window.addEventListener("scroll", updateHeaderState, {
    passive: true,
  });

  window.addEventListener("pageshow", updateHeaderState);
})();